export default __webpack_public_path__ + "static/media/404-error-img.39913bd4.webp";